import { GroupTag, TagHeader } from "../TagHeaderModal/styles/stylesHeader";

interface propsTagHeaderModal {
  tagsHeader: {
    label: string;
    content: string;
    isolated?: boolean;
  }[];
}

export const TagHeaderModal = ({ tagsHeader }: propsTagHeaderModal) => {
  return (
    <>
      <GroupTag>
        {tagsHeader.map((tag) => {
          return (
            !tag?.isolated && (
              <TagHeader label={tag.label}>{tag.content}</TagHeader>
            )
          );
        })}
      </GroupTag>
      {tagsHeader.map((tag) => {
        return (
          tag?.isolated && (
            <GroupTag>
              <TagHeader label={tag.label}>{tag.content}</TagHeader>
            </GroupTag>
          )
        );
      })}
    </>
  );
};
